import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Link, useNavigate } from "react-router-dom";
import Images from "../Images";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
} from "../Components/Styles/PageStyles";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import {
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  SubmitBtn,
  PreviewBtn,
  FormContainerVertical,
  CombineInputGroup
} from "../Components/Styles/InputStyles.jsx";
import DropZone from "../Components/Dropzone";
import Loading from "../Components/Loading";
import { useMutation } from "react-query";
import Config from "../Config";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Update_User } from "../Redux/actions";
import SelectSearch from "react-select-search";
import "../select-search.css";
import Fuse from "fuse.js";
import ChangePasswordModal from "../Components/ChangePasswordModal";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import { MdPassword } from "react-icons/md";


const Guidelines = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [changePasswordModel, setChangePasswordModel] = useState(false);

  const user = useSelector((state) => state.UserReducer.user);

  
  return (
    <>  
    <Navbar />
    <Page>
      <BoxContainer>
      <div className="flex w-full justify-between items-center">
        <div>
          <Title>UTARATIBU WA KUSAJILI CHAMA / KLABU NA MABADILIKO YA VIFUNGU VYA KATIBA ZA VYAMA VYA MICHEZO</Title>
          <Underline />
          {/* Start of first guideline */}
          <SubTitle>1. UTARATIBU WA KUSAJILI</SubTitle>
          <ul class="list-disc pl-5 space-y-3 text-gray-700 mt-4">
            <li>Kiongozi Kufungua akaunti na kujisajili taarifa zake katika mfumo.</li>
            <li>Kiongozi Kupakua na kujaza sampluli za katiba na kanuni katika mfumo.</li>
            <li>Kiongozi wa Chama ataweka taarifa muhimu za Chama anachotaka kukisajili ikiwemo Jina la Chama, Aina ya Mchezo, Anuani, Mkoa.</li>
            <li>Kutuma maombi BMT kupitia mfumo huu. Maombi haya yaambatanishe na kuweka katika mfumo nyaraka zifuatazo: -
              <ul role="list" class="list-decimal pl-5 space-y-3 text-gray-700 mt-4">
                <li>Muhtasari wa kikao cha Wanachama kilichofikia uamuzi wa kuunda chamana kupitisha Katiba,</li>
                <li>Nakala ya Katiba ya Chama,</li>
                <li>Nakala ya Kanuni za fedha za chama,</li>
                <li>Nakala ya Kanuni za uendeshaji wa shughuli za Chama,</li>
                <li>Orodha ya majina ya Uanachama wake na namba za Uanachama kwa Msajili.</li>
                <li>Kujaza fomu za usajili NSC 01  na NSC 02.</li>
                <li>Kiongozi atengeneze namba ya malipo (Control No., na kulipia gharama za usajili  kwa ajili ya kulipia gharama za usajili wa chama alichoomba. (CONTROL Na. mbili, moja ilipiwe wilayani, nyingine iwasilishwe BMT.</li>
              </ul>
              <br/>
              <li>Kuwasilisha taarifa kwa msajili msaidizi.</li>
              <li>Baada ya kuwasilishwa maombi kwenye mfumo, Msajili Msaidizi atapitia taarifa za chama pamoja na fomu alizojaza na kama ziko sawa  atatuma maombi hayo kwa Msajili wa Vyama vya Michezo, BMT.
              </li>
            </li>
              <li>Msajili akishayapokea maombi hayo katika mfumo atayahakiki na endapo hataona upungufu wowote, atakisajili Chama hicho kwa kufanya yafuatayo:-
              <ul role="list" class="list-decimal pl-5 space-y-3 text-gray-700 mt-4">
                <li>Kufanya usajili</li>
                <li>Kutoa nakala  hati ya Usajili;</li>
                <li>Kuchukua nakala ngumu ya cheti kutoka kwa msajili msaidizi.</li>
              </ul>
              </li>
          </ul>
          {/* End of first guedeline */}

          { /* Second Guideline */ }
          <SubTitle>2. SIFA ZA KATIBA ZA VYAMA VYA MICHEZO</SubTitle>
          <ul class="list-disc pl-5 space-y-3 text-gray-700 mt-4">
          <span>Kila Katiba ya chama inatakiwa kuonyesha kwa uwazi mambo muhimu yafuatayo:-</span>
            <li>Jina la Chama</li>
            <li>Anuani kamili, ikiwa na Mtaa au Kijiji, namba ya nyumba au Ofisi, namba ya sanduku la Posta na Simu kama ipo na pia Mji, Wilaya na Mkoa;</li>
            <li>Madhumuni;</li>
            <li>Idadi na aina ya Michezo;</li>
            <li>Muundo wa Chama;</li>
            <li>Wajibu na kazi za Kamati mbalimbali</li>
            <li>Wajibu na kazi za Viongozi na Wanachama;</li>
            <li>viii.	Kalenda ya:
              <ul role="list" class="list-decimal pl-5 space-y-3 text-gray-700 mt-4">
                <li>Mikutano ya Kamati ndogo ndogo;</li>
                <li>Mikutano ya Kamati ya Utendaji;</li>
                <li>Mikutano Mikuu;</li>
                <li>Mkutano Mkuu wa Uchaguzi.</li>
                <li>Taratibu za kushuguhulikia migogoro na rufaa;</li>
                <li>Vipindi vya Uongozi;</li>
                <li>Sifa za Wagombea Uongozi ziwekwe bayana, kulingana na aina ya mchezo, utaalam,uzoefu, kiwango cha Elimu na ngazi ya chama husika kwa mujibu wa Sera ya Maendeleo nya Michezo.</li>
                <li>Kila Katiba ionyeshe kuwa Chama kitafanya kazi zake chini ya Sheria Na. 12 ya BMT ya mwaka 1967.</li>
              </ul>
            </li>
          </ul>
          { /* End Second Guideline */ }


          { /* Third Guideline */ }
          <SubTitle>3. MAREKEBISHO YA KATIBA</SubTitle>
          <ul class="list-disc pl-5 space-y-3 text-gray-700 mt-4">
            <li>Chama chochote kitakachofanya mabadiliko ya jina, anwani, madhumuni au kifungu chochote cha Katiba yake kitatakiwa kupata idhini kwa kupeleka maombi kwa Msajili kupitia Msajili Msaidizi kwa kujaza fomu za maombi Na. BMT 6,7, 8 na 9 kulingana na marekebisho yatakayofanyika.  Baada ya Msajili kufanyia kazi maombi hayo, atawajulisha wahusika kwa maandishi kuhusu kukubaliwa au kukataliwa kwao katika kipindi cha siku 14 tangu kupokelewa maombi yao;</li>
            <li>Msajili anaweza kuyakataa maombi ya Chama kubadili jina lake ikiwa:-
              <ul role="list" class="list-decimal pl-5 space-y-3 text-gray-700 mt-4">
                <li>Jina jipya linafanana na jina la Chama kingine kilichosajiliwa mahali popote hapa nchini.</li>
                <li>Jina jipya linakaribia kufanana na  chama kingine chochote kiasi kwamba linawezakuleta utata miongoni mwa jamii nzima au wananchama wenyewe;</li>
                <li>Anaona kuwa jina hilo halifai;</li>
                <li>Kwa maelekezo ya Waziri.</li>
                <br/>
              </ul>
              <li>Msajili anaweza akayakataa maombi yoyote ya kubadili kifungu chochote cha Katiba ya Chama au Kanuni za Chama ikiwa:-
              <ul role="list" class="list-decimal pl-5 space-y-3 text-gray-700 mt-4">
                <li>Anaona kuwa mabadiliko hayoyanaweza kuhatarisha usalama na kuvuruga amani miongoni mwa wanachama na jamii kwa ujumla na hivyo kuathiri maendeleo ya chama;</li>
                <li>Atabaini kuwa mabadiliko hayo yanalenga kuwanufaisha wachache;</li>
                <li>Anaona kuwa mabadiliko hayo yatakifanya chama kuingilia shughuli za Chama kingine na kuathiri utekelezaji wa shughuli za Chama hicho kingine;</li>
                <li>Anaona kuwa mabadiliko hayo hayafai kwa kuwa hayazingatii Sera ya Michezo, Sera ya Utamaduni na Sheria ya Baraza la Michezo la Taifa;</li>
                <li>Kwa maelekezo ya Waziri;</li>
                <br/>
              </ul>
              </li>
              <li>Endapo Msajili atakataa maombi yoyote ya kubadili kifungu chochote cha Katiba ya Chama aawajulisha wahusika kwa kutumia fomu Na. BMT. 10.</li>
              <li>Endapo Msajili ataafiki mabadiliko yaliyofanyika atatoa idhini kwa chama kutumia fomu Na. BMT. 11.</li>
              <li>Baada ya kupokea taarifa ya kukatalia maombi yao, Chama hicho kinaruhusiwa kukara rufaa kwa Waziri katika kipindi cha siku 21 kuanzia tarehe ya kukataliwa;</li>
              <li>Uamuzi wowote utakaotolewa na Waziri utakuwa wa mwisho;</li>
              <li>Msajili ataingiza taarifa yoyote ya marekebisho katika vitabu vya kumbukumbu kwa kadri atakavyoipokea kwa mujibu wa kanuni hizi;</li>
              <li>Msajili atatoa hati mpya ya usajili kwa chama chochote kilichokubaliwa kubadilisha jina baada ya Chama hicho kurejesha hati yake ya mwanzo.</li>
            </li>
          </ul>
          { /* End Third Guideline */ }

          { /* Fourth Guideline */ }
          <SubTitle>VIGEZO VYA KUSAJILI AKADEMIA, KITUO NA KLABU ZA MICHEZO</SubTitle>

          <SubTitle>AKADEMIA (SHULE) YA MICHEZO</SubTitle>
          <ul class="list-disc pl-5 space-y-3 text-gray-700 mt-4">
            <li>Kuwa na ofisi za akademia</li>
            <li>Kuwa na kiwanja/ viwanja vya michezo, chumba cha mazoezi nk</li>
            <li>Kuwa na vifaa vya wachezaji na vifaa vya michezo</li>
            <li>Kuwa na Walimu au kuwepo uwezekano wa kupata walimu wa michezo na wataalam wengine wa michezo</li>
            <li>kuwa na huduma ya chakula na malazi kulingana na mahitaji ya watu wote</li>
            <li>Kuwa na madarasa kwa ajili ya kufundishia vipindi vya masomo, semina n.k</li>
          </ul>
          { /* End Fourth Guideline */ }

          { /* Fifth Guideline */ }
          <SubTitle>KITUO CHA MICHEZO</SubTitle>
          <ul class="list-disc pl-5 space-y-3 text-gray-700 mt-4">
            <li>Kuwa na ofisi za Kituo</li>
            <li>Kuwa na kiwanja/ viwanja vya michezo, chumba cha mazoezi nk</li>
            <li>Kuwa na vifaa vya wachezaji na vifaa vya michezo</li>
            <li>Kuwa na Walimu au kuwepo uwezekano wa kupata walimu wa michezo na wataalam wengine wa michezo.</li>
            <li>Kuwa na huduma ya maliwato inayokidhi mahitaji ya watu wote</li>
            <li>Kuwa na walau darasa moja kwa ajili ya mafunzo ya nadharia</li>
          </ul>
          { /* End Fifth Guideline */ }


          { /* Sixth Guideline */ }
          <SubTitle>KLABU ZA MICHEZO</SubTitle>
          <ul class="list-disc pl-5 space-y-3 text-gray-700 mt-4">
            <li>Kuwa na ofisi za Klabu</li>
            <li>Kuwa na kiwanja/ viwanja vya michezo, chumba cha mazoezi nk</li>
            <li>Kuwa na vifaa vya wachezaji na vifaa vya michezo</li>
            <li>Kuwepo uwezekano wa kupata walimu wa 	michezo na wataalam wengine wa michezo</li>
            <li>Kuwa na huduma ya maliwato inayokidhi mahitaji ya watu wote</li>
          </ul>
          { /* End Sixth Guideline */ }



        </div>
      </div>
      </BoxContainer>
    </Page>
    </>
  );
};

const Uploader = ({ setChangePasswordModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setChangePasswordModel(true)}>
        <MdPassword className="text-white w-5 h-5" /> <p>Change Password</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const SubmitBtnWrapper = tw.div`
mt-10 `;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const SubTitle = tw.h3`text-lg  text-gray-800 whitespace-nowrap   font-medium mt-4`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default Guidelines;
